module.exports = __webpack_public_path__ + "img/John Hammock.5a97358e.jpg";